<template>
  <!--  <div class="swiper-wrapper">
     <ul class="con-common-msg swiper-slide flex-column">
        <li class="msg-list flex-row align-center" v-for="(item,index) in list" :key="index">
          <span class="msg-no">{{item.No}}</span>
          <div class="msg-name">
            {{item.CusInfo}}
            <p>张* <span class="patient-de">（男/23岁）</span></p>
            <p class="patient-phone">184****0874</p>
          </div>
          <span class="msg-class">{{item.DisName}}</span>
          <span class="msg-num">{{item.FetchCode}}</span>
        </li>
      </ul>
  </div> -->
  <ul class="con-common-msg swiper-wrapper  flex-column">
    <li class="msg-list flex-row align-center swiper-slide" v-for="(item,index) in list" :key="index" :class="[DataType==2?'msg-list-8':'msg-list-5']">
      <span class="msg-no" :style="{'width':DataType==2?'260px':'110px'}">{{item.No}}</span>
      <div class="msg-name" :style="{'width':DataType==2?'700px':'320px'}"  v-html="setInfo(item.CusInfo)">
      </div>
      <span class="msg-class" v-if="types=='py'">{{item.DisName}}</span>
      <span class="msg-num" :style="{'text-align':DataType==2?'center':'right'}">{{item.FetchCode}}</span>
    </li>
  </ul>
  <!-- <ul class="con-common-msg swiper-wrapper  flex-column">
    <li class="msg-list flex-row align-center swiper-slide" v-for="(item,index) in 30" :key="index" :class="[DataType==2?'msg-list-8':'msg-list-5']">
      <span class="msg-no" :style="{'width':DataType==2?'260px':'110px'}">{{index}}</span>
      <div class="msg-name" :style="{'width':DataType==2?'700px':'320px'}">
        张* <span class="patient-de">（男/23岁）</span>18487308470
      </div>
      <span class="msg-class" v-if="types=='py'">23123213213213213</span>
      <span class="msg-num" :style="{'text-align':DataType==2?'center':'right'}">15151515</span>
    </li>
  </ul> -->
</template>
<script>
export default {
  name: '',
  props: {
    list: {
      type: Array
    },
    types: {
      type: String,
      default: 'py'
    },
    DataType: {
      type: [String, Number],
      default: 3
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    setInfo (data) {
      let name = data.split('（')[0]
      let nameNo = name.length > 2 ? '**' : '*'
      let setName = name[0] + nameNo
      let phone = data.split('）')[1]
      let reg = /(\d{3})\d{4}(\d{4})/
      // eslint-disable-next-line no-unused-vars
      let setphone = phone.replace(reg, '$1****$2')
      let age = data.substring(data.indexOf('（'), data.indexOf('）') + 1)
      // return setName + age + '<br />' + setphone
      return setName + age + '' + setphone
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/orderList.vue